export default __webpack_public_path__ + "static/ringpour-452142bf91486a8e801ede65b5f7a996.png";